export const formatGBP = (value: number | null): string => {
    if (value === null) return '-'
    return new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP',
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
    }).format(value)
}

export const formatShortDate = (value: string | null): string => {
    if (!value) return '-'
    return new Intl.DateTimeFormat('en-GB', {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
    }).format(new Date(value))
}

export const formatPercent = (value: number | null): string => {
    if (value === null) return '-'
    return `${(value * 100).toFixed(0)}%`
}

export const htmlToPlainText = (value: string | null | undefined): string => {
    if (value == null || value === '') return ''
    const div = document.createElement('div')
    div.innerHTML = value
    return div.textContent?.trim() ?? ''
}

export const formatDetailChangeMessage = (
    fieldName: string,
    oldValue: string | null | undefined,
    newValue: string | null | undefined,
): string => {
    const plainOld = htmlToPlainText(oldValue)
    const plainNew = htmlToPlainText(newValue)

    if (!plainOld && plainNew) {
        return `${fieldName} added ${plainNew}`
    }
    if (plainOld && !plainNew) {
        return `${fieldName} removed`
    }
    return `${fieldName} changed from ${plainOld} to ${plainNew}`
}
